import { t as o } from "./ZudokuContext-Coxa0DfE.js";
const n = (s = []) => ({
  getRoutes: () => {
    const e = [];
    return o(s, (t) => {
      t.type === "custom-page" && e.push({
        path: t.path,
        element: t.element
      });
    }), e;
  }
});
export {
  n as customPagesPlugin
};
//# sourceMappingURL=zudoku.plugin-custom-pages.js.map
